module.exports = __webpack_public_path__ + "static/media/nike_jordan_box.4f76de70.png";